<template>
    <div class="hubspot-chat-button-fixed">
        <div v-if="areStatisticsCookiesEnabled">
            <div :class="{ 'hubspot-chat-button-fixed__hubspot-chat-wrapper': true, 'hubspot-chat-button-fixed__hubspot-chat-wrapper--visible': hubspotChatIsOpen }">
                <HubSpotChat @hide-chat-requested="toggleChat" wrapper_id="hubspot-chat-only"/>
            </div>
            <button v-if="!hubspotChatIsOpen" @click="toggleChat" class="hubspot-chat-button-fixed__button">
                <span
                    class="hubspot-chat-button-fixed__unread-conversations-count"
                    v-if="unreadConversationsCount > 0">{{ unreadConversationsCount }}</span>
                <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="35" cy="35" r="35" fill="#446699"
                        :style="$isLangDk ? 'fill: #F7B200;' : ''"
                    />
                    <path
                        d="M26.7391 20.4168H50.2613C51.5437 20.4168 52.6016 21.3897 52.7034 22.6401L53.0835 27.3088V31.331L52.6578 37.9857C52.5767 39.2533 51.5114 40.2502 50.2127 40.2502H26.7739C25.4798 40.2502 24.4165 39.2601 24.3295 37.9973L23.9168 32.007V27.3088L24.2969 22.6401C24.3987 21.3897 25.4567 20.4168 26.7391 20.4168ZM33.314 37.6668H37.9946H44.6974V36.5002H37.9946H33.314V37.6668Z" fill="white" stroke="white" stroke-width="1.16667"
                        :style="$isLangDk ? 'fill: #333333; stroke: #333333;' : ''"
                    />
                    <path d="M20.263 22.7503H47.404C48.924 22.7503 50.1892 23.9177 50.3112 25.4329L50.7502 30.884V35.584L50.2588 43.3511C50.1616 44.8874 48.8873 46.0837 47.3479 46.0837H20.3032C18.7693 46.0837 17.4975 44.8956 17.3932 43.3652L16.9168 36.3729V30.884L17.3557 25.4329C17.4777 23.9178 18.7429 22.7503 20.263 22.7503Z" fill="white" stroke="#446699" stroke-width="1.16667"
                        :style="$isLangDk ? 'fill: #333333; stroke: #F7B200;' : ''"
                    />
                    <path d="M33.8333 50.167L29.7919 44.917H37.8748L33.8333 50.167Z" fill="white"
                        :style="$isLangDk ? 'fill: #333333; stroke: #333333;' : ''"
                    />
                </svg>
            </button>
        </div>
        <div v-else>
            <HubspotDisabledPopup />
        </div>
    </div>
</template>

<script>
    import HubSpotChat from 'components/chatbot/customer_support/HubSpotChat.vue'
    import HubspotDisabledPopup from 'components/cookieconsent/HubspotDisabledPopup.vue'
    import hubSpotChatHelper from 'components/shared/mixins/hubSpotChatHelper'

    export default {
        name: 'HubSpotChatOnly',
        components: { HubSpotChat, HubspotDisabledPopup },
        mixins: [hubSpotChatHelper]
    }
</script>

<style scoped lang="scss">
.hubspot-chat-button-fixed {
    font-family: Nunito-Regular, sans-serif;
    position: fixed;
    right: 20px;
    bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-content: flex-end;
    z-index: 9991;
    gap: 1rem;

    &__button {
        appearance: none;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        margin: 0;
        align-self: flex-end;
        font-family: Nunito-Regular, sans-serif;
        position: fixed;
        right: 20px;
        bottom: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-content: flex-end;
        z-index: 9990;
        gap: 1rem;

        &--disabled {
            opacity: 0.7;
        }

        img {
            box-shadow: 0 0 6px 0 #00000040;
            border-radius: 50%;
        }

    }

    &__unread-conversations-count {
        position: absolute;
        top: 0;
        right: 0;
        box-shadow: 0 0 6px 0 #00000040;
        width: 20px;
        height: 20px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        font-size: 12px;
        color: $white;
        background: $metallic_red;
        border-radius: 50%;
    }

    &__hubspot-chat-wrapper {
        transition: opacity 0.2s ease-in-out;

        &--visible {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
            display: block;
        }

        &:not(&--visible) {
            opacity: 0;
            visibility: hidden;
            pointer-events: none;
            display: none;
        }
    }

    &__message {
        background: $alabaster;
        width: 288px;
        padding: 20px;
        border-radius: 10px 10px 0 10px;
        border: 1px solid $rust_orange;
        box-shadow: 0 0 6px 0 #00000040;

        &__icon-info-solid {
            color: $rust_orange;
        }

        a {
            color: $rust_orange;
            font-weight: bold;
            text-decoration: underline;
        }

        &__header {
            display: flex;
            justify-content: flex-start;
            gap: 1rem;
            margin-bottom: 1rem;

            &__close-button {
                margin-left: auto;
                box-shadow: none;
                appearance: none;
            }
        }
    }
}
</style>
